"use client";
import CoachLandingCard from "@/components/Coachs/CoachLandingCard";
import Link from "next/link";
import {useState} from "react";
import {useKeenSlider} from "keen-slider/react";
import "keen-slider/keen-slider.min.css"
export default function CoachSection({coachs}){
    const [currentSlide, setCurrentSlide] = useState(0);
    const [load, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider({
        initial : 0,

        breakpoints: {

            "(min-width: 200px)": {
                slides: { perView: 1, spacing: 5 },
            },
            "(min-width: 400px)": {
                slides: { perView: 1, spacing: 5 },
            },
            "(min-width: 550px)": {
                slides: { perView: 3, spacing: 10 },
            },
            "(min-width: 1000px)": {
                slides: { perView: 4, spacing: 20 },
            },
            "(min-width: 1500px)": {
                slides: { perView: 5, spacing: 20 },
            },
            "(min-width: 1700px)": {
                slides: { perView: 6, spacing: 30 },
            },
        },
        slides: { perView: 3, spacing : 50 },
        slideChanged(slider){
            setCurrentSlide(slider.track.details.rel)
        },
        created(){
            setLoaded(true)
        }
    })

    return(
      <section className={"bg-cwfYellow py-20 flex flex-col gap-y-10"}>
          <h2 className={"text-center text-white font-medium text-4xl"}>Nos professionnels</h2>
          <div className={"keen-slider px-20 py-10"} ref={sliderRef}>
              {coachs.map(function(coach){
                  return(
                      <div key={coach.id} className={"keen-slider__slide py-10"}>
                          <CoachLandingCard
                              id={coach.id}
                              job={coach.job}
                              firstname={coach.firstname}
                              lastname={coach.lastname}
                              description={coach?.profile?.bio}
                              rates={coach.reviews_avg_rates}
                              path={coach.docs[0]?.path}
                              speciality={coach.speciality}
                              hourlyRates={coach?.profile?.hourly_rate}
                          />
                      </div>
                  )
              })}
          </div>
          <div className={"flex justify-center"}>
              <Link href={"/pros"}>
                  <button
                      className={"border border-cwfGreen bg-white text-xl py-2 px-6 rounded-full text-cwfGreen font-semibold hover:text-white hover:bg-cwfGreen"}
                  >
                      Découvrir plus
                  </button>
              </Link>
          </div>

      </section>
    );
}